export { DMS_MODULE } from '../constants';
export const CRUMB_LABEL_KEY = 'grdEDIMAP';
export const NAME_API = 'EdiMap';
export const NAME = 'ElektronickaFakturace';
